import React from "react";

import {
  BackgroundRemove,
  BlurTattoo,
  CoverPrivates,
  NoFace,
} from "../../../assets";
import { APP_TOKENS as tokens } from "../../../styles/tokens";

export type TImageFilterIconName =
  | "add"
  | "delete"
  | "duplicate"
  | "download"
  | "image-tools"
  | "privacy"
  | "remove-background"
  | "face"
  | "tattoo";

const ICON_PATHS: Record<TImageFilterIconName, string> = {
  add: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z",
  delete:
    "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12ZM8 9h8v10H8V9Zm7.5-5-1-1h-5l-1 1H5v2h14V4h-3.5Z",
  duplicate:
    "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1Zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm0 16H8V7h11v14Z",
  download:
    "M19 9h-4V3H9v6H5l7 7 7-7Zm-8 2V5h2v6h1.17L12 13.17 9.83 11H11Zm-6 7v2h14v-2H5Z",
  "image-tools":
    "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2ZM8.5 11.5l2.5 3.01L14.5 10l4.5 6H5l3.5-4.5ZM17.5 8A1.5 1.5 0 1 1 17.5 5a1.5 1.5 0 0 1 0 3Z",
  privacy:
    "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4Zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8Z",
  "remove-background":
    "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 16H5V5h14v14ZM7 17h2v-2H7v2Zm0-4h2v-2H7v2Zm0-4h2V7H7v2Zm4 8h2v-2h-2v2Zm0-8h2V7h-2v2Zm4 8h2v-2h-2v2Zm0-4h2v-2h-2v2Zm0-4h2V7h-2v2Z",
  face: "M9 11.75c-.69 0-1.25-.56-1.25-1.25S8.31 9.25 9 9.25s1.25.56 1.25 1.25S9.69 11.75 9 11.75Zm6 0c-.69 0-1.25-.56-1.25-1.25S14.31 9.25 15 9.25s1.25.56 1.25 1.25S15.69 11.75 15 11.75ZM12 17c2.33 0 4.31-1.46 5.11-3.5H6.89C7.69 15.54 9.67 17 12 17Zm0-15a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z",
  tattoo:
    "M7.5 2C5.57 2 4 3.57 4 5.5c0 1.58 1.05 2.92 2.5 3.35V22h2v-6h2v6h2V8.85A3.5 3.5 0 0 0 11.5 2h-4Zm0 2h4a1.5 1.5 0 0 1 0 3h-4a1.5 1.5 0 0 1 0-3Zm8 3v2H18v2h-2.5v2H18v2h-2.5v2H18v2h-2.5v3h-2V7h2Z",
};

const ImageFilterIcon: React.FC<{
  name: TImageFilterIconName;
  color?: string;
  size?: number;
}> = ({ name, color = tokens.color.textPrimary, size = 24 }) => {
  const originalAsset = (() => {
    switch (name) {
      case "tattoo":
        return <BlurTattoo color={color} size={size} />;
      case "remove-background":
        return <BackgroundRemove color={color} size={size} />;
      case "face":
        return <NoFace color={color} size={size} />;
      case "privacy":
        return <CoverPrivates color={color} size={size} />;
      default:
        return null;
    }
  })();

  if (originalAsset) {
    return (
      <span
        aria-hidden="true"
        data-original-ai-tool-asset={name}
        style={{ display: "inline-flex" }}
      >
        {originalAsset}
      </span>
    );
  }

  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d={ICON_PATHS[name]} fill={color} />
    </svg>
  );
};

export default ImageFilterIcon;
